import { IntroScreenUIConfig } from "../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../components/ui/scenario-info-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import GameManager from "../cvp-webgames-core/GameManager";
import Tools from "../cvp-webgames-core/Misc/Tools";
import BaseScenarioPart from "../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../cvp-webgames-core/pre-caching/pre-cache-item";
import { constants } from "../misc/constants";
import { CustomGameDataManager, PageType, updateMentorVideo } from "../misc/tools";
import { GameBaseScenario } from "./GameBaseScenario";

class Scenario4VideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Inpatient Veteran Setting';
    }

	public videoKey = 'Video';
	public get mentorVidUrl(): string {
		return this.getItems()[1].src;
	}

	public cinematicKeys = {
		chapter1: 'chapter1', //played on step 2
		chapter1Resume: 'chapter1-resume',

		chapter2: 'chapter2', //played on step 5
		chapter2Resume: 'chapter2-resume',

		chapter3: 'chapter3', //played on step 7
		chapter3Resume: 'chapter3-resume',

		chapter4: 'chapter4', //played on step 9
		chapter4Resume: 'chapter4-resume',
    };

	public mentorKeys = {
		situation: 'mentor-2', //played on situation screen
		mentor1Correct: 'mentor-1', //played on ____ correct
		mentor1Incorrect: 'mentor-1', //played on ____ incorrect
		review: 'mentor-3', //played on review screen

		BnScn04All001: 'Bn-Scn-04-All-001',
		BnScn04All006: 'Bn-Scn-04-All-006',
		BnScn04All009: 'Bn-Scn-04-All-009',
		BnScn04All011: 'Bn-Scn-04-All-011',
		BnScn04All012: 'Bn-Scn-04-All-012',
		BnScn04All014: 'Bn-Scn-04-All-014',
		BnScn04All016: 'Bn-Scn-04-All-016',
		BnScn04All017: 'Bn-Scn-04-All-017',
		BnScn04All019: 'Bn-Scn-04-All-019',
		BnScn04All021: 'Bn-Scn-04-All-021',
		BnScn04All023: 'Bn-Scn-04-All-023',
		BnScn04All025: 'Bn-Scn-04-All-025',
		BnScn04All026: 'Bn-Scn-04-All-026',
		BnScn04All028: 'Bn-Scn-04-All-028',
		BnScn04All030: 'Bn-Scn-04-All-030',
		BnScn04All036: 'Bn-Scn-04-All-036',
		BnScn04All038: 'Bn-Scn-04-All-038',
		BnScn04All039: 'Bn-Scn-04-All-039',
		BnScn04All041: 'Bn-Scn-04-All-041',
		BnScn04All043: 'Bn-Scn-04-All-043',
		BnScn04All044: 'Bn-Scn-04-All-044',
		BnScn04All046: 'Bn-Scn-04-All-046',
		BnScn04All048: 'Bn-Scn-04-All-048',
		BnScn04All049: 'Bn-Scn-04-All-049',
		BnScn04All052: 'Bn-Scn-04-All-052',
		BnScn04All054: 'Bn-Scn-04-All-054',
		BnScn04All056: 'Bn-Scn-04-All-056',
		BnScn04All058: 'Bn-Scn-04-All-058',
		BnScn04All063: 'Bn-Scn-04-All-063',
		BnScn04All065: 'Bn-Scn-04-All-065',
		BnScn04All066: 'Bn-Scn-04-All-066',
		BnScn04All068: 'Bn-Scn-04-All-068',
		BnScn04All070: 'Bn-Scn-04-All-070',
		BnScn04All071: 'Bn-Scn-04-All-071',
		BnScn04All074: 'Bn-Scn-04-All-074',
		BnScn04All076: 'Bn-Scn-04-All-076',
		BnScn04All077: 'Bn-Scn-04-All-077',
		BnScn04All079: 'Bn-Scn-04-All-079',
		BnScn04All081: 'Bn-Scn-04-All-081',
		BnScn04All082: 'Bn-Scn-04-All-082',
		BnScn04All084: 'Bn-Scn-04-All-084',
		BnScn04All087: 'Bn-Scn-04-All-087',
		BnScn04All093: 'Bn-Scn-04-All-093',
		BnScn04All095: 'Bn-Scn-04-All-095',
		BnScn04All096: 'Bn-Scn-04-All-096',
		BnScn04All098: 'Bn-Scn-04-All-098',
		BnScn04All100: 'Bn-Scn-04-All-100',
		BnScn04All101: 'Bn-Scn-04-All-101',
		BnScn04All103: 'Bn-Scn-04-All-103',
		BnScn04All105: 'Bn-Scn-04-All-105',
		BnScn04All106: 'Bn-Scn-04-All-106',
		BnScn04All108: 'Bn-Scn-04-All-108',
		BnScn04All110: 'Bn-Scn-04-All-110',
		BnScn04All111: 'Bn-Scn-04-All-111',
		BnScn04All113: 'Bn-Scn-04-All-113',
		BnScn04All115: 'Bn-Scn-04-All-115',
    };
	
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: this.videoKey,
				src: process.env.PUBLIC_URL + '/assets/videos/scenario-04/video.mp4',
				type: PrecacheItemType.Video
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/mentor-vids/scn-04/Mentor-Bs-Scn-04-Full.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const scenario4VideoSegments = new Scenario4VideoSegments();


export default class Scenario4 extends GameBaseScenario {
	public partId = 'scenario';
	
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return null;
    }

	public get MentorTalkingVideo(): string {
		return scenario4VideoSegments.mentorVidUrl;
    }

	public resumeScenarioFromArea(areaIndx: number): void {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			this.hudId = this.uiWrapper.displayHUD({
			});
			//resume on or after the first question
			let onDone: () => void = null;
			let chapterId: string = null;
			switch(areaIndx) {
				case 0:
					chapterId = scenario4VideoSegments.cinematicKeys.chapter1Resume;
					onDone = () => this.step4();
					break;
				case 1:
					chapterId = scenario4VideoSegments.cinematicKeys.chapter2Resume;
					onDone = () => this.step6();
					break;
				case 2:
					chapterId = scenario4VideoSegments.cinematicKeys.chapter3Resume;
					onDone = () => this.step8();
					break;
				case 3:
					chapterId = scenario4VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step10();
					break;
				case 4:
					chapterId = scenario4VideoSegments.cinematicKeys.chapter4Resume;
					onDone = () => this.step12();
					break;
			}
	
			setTimeout(() => {
				this.playVideoChapter(this.partId, chapterId, () => {
					onDone();
				}, false)
			}, 250);
		});
	}

	public scenarioIndex(): number {
		return 3;
    } 

	public scenarioId(): PageType {
		return PageType.Scenario4;
    }
	private video: SingleVideoSegmentItem = scenario4VideoSegments.getItemByKey(scenario4VideoSegments.videoKey);

	public getScenarioVideoURL(): string {
		return this.video.src;
	}


	public introScreenInfo(): IntroScreenUIConfig {
		return null
	}

	private parts: BaseScenarioPart<GameBaseScenario>[] = [{
		partId: this.partId,
		scenario: this,
		videoUrl: [scenario4VideoSegments.getItemByKey(scenario4VideoSegments.videoKey).src],
		start: () => {
		},
		playVideoChapter: (chapterId: string, onDone: () => void) => {
			(this.playVideoChapter(this.partId, chapterId, onDone, false))
		}
	}]

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	start() {
		this.step0();
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	//load video
	step0() {
		// this.loadPart(this.partId, () => {
			this.step1();
		// });
	}

	//1.	Scenario Intro
	step1() {
		updateMentorVideo(true, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All001);

		this.hudId = this.uiWrapper.displayHUD({
		});
		this.uiWrapper.displayIntroScreenUI({
			title: 'Situation',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You are a staff in the inpatient mental health unit. Your role is to observe and do check-ins with 
					Veterans while they are in the dayroom waiting for a treatment group to begin. As you are walking through 
					the room you hear two Veterans making fun of another Veteran's mannerisms and clothing. They are speaking 
					loud enough that some of the other Veterans in the room can hear their comments as well. There is enough 
					information to know who they are speaking about.
				</p>
				<br />
				<p class="black-text">
					The goal will be to identify the ERASE techniques, bystander intervention techniques, requirements outlined 
					in VHA Directive 5019.02, and VA Handbook 5979 throughout the scenario. You are currently the only staff member 
					on this side of the room when this occurs, as your teammate is on the other side of the room busy handing out 
					cups of water and talking with other Veterans in the dayroom.
				</p>
			</div>
			`,
			spaceForMentor: true,
			audioUrls: null,
			onStartScenarioClicked: () => {
				this.step2();
			}
		})
	}

	//2.	Cinematic 1 (Video)
	step2() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter1, () => {
			this.step3();
			this.step3b();
		}, false)
	}

	//3.	Display UI
	step3() {
		
	}

	//3-b.	Time passes
	step3b() {
		//UNCOMMENT FOR MENTOR
		updateMentorVideo(true, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All006);

		this.uiWrapper.displayIntroScreenUI({
			title: 'Information',
			buttonText: 'Continue',
			htmlData: `
			<div>
				<p class="black-text">
					You are walking around the dayroom and observing patients, you overhear this conversation and 
					realize they are talking about another patient who is transgender.
				</p>
			</div>
			`,
			audioUrls: null,
			spaceForMentor: true,
			onStartScenarioClicked: () => {
				this.step4();
			},
			onReplayContentClicked: () => {
				this.step2();
			}
		})
	}

	//4.	Question 1
	step4(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All009);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All011, scenario4VideoSegments.mentorKeys.BnScn04All012],
			isCorrect: true,
			description: 'You immediately state: “Veterans, I would like to remind you that while you are on this unit, everyone is to be respectful, both of oneself and of others. I heard what you were saying about another patient here and that is not being respectful.”',
			feedbackHtml: 'Correct! Following the ERASE model, this is an effective example of Encouraging discussion and training on how to handle mistreatment. This is an example of reminding patients of VHA\'s Rights and Responsibilities of VA Patients and Residents of Community Living Centers. At admission, all units should be providing patients with an orientation regarding behaviors, and reinforcement of respect to one another should be emphasized in daily unit community meetings. This is also using the A from the ERASE model by addressing the situation in real time.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All014]
		}, {
			title: 'Option 2',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All016, scenario4VideoSegments.mentorKeys.BnScn04All017],
			isCorrect: true,
			description: 'You know this is not good, but you don\'t know what to do so you walk over to the other staff in the dayroom and let them know what you overheard. The staff reminds you of VHA\'s Rights and Responsibilities of VA Patients and Residents of Community Living Centers, that patients are informed of these rights and responsibilities at admission, and at community meetings. You return to the Veterans and state: “Veterans, I would like to remind you that while you are on this unit, everyone is to be respectful, both of oneself and of others. I heard what you were saying about another patient here and that is not being respectful.”',
			feedbackHtml: 'Correct! This is an example of reminding patients of VHA\'s Rights and Responsibilities agreement. At admission, all units should be providing patients with an orientation regarding behaviors, and reinforcement of respect to one another should be emphasized in daily unit meetings. This is using the S from the ERASE model by getting Support from colleagues.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All019]
		}, {
			title: 'Option 3',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All021],
			isCorrect: false,
			description: 'You don\'t do anything, as you aren\'t sure what to do.',
			feedbackHtml: 'Not the best answer! According to the ERASE model "Addressing" behaviors in real time is the most effective redirection. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All023]
		}, {
			title: 'Option 4',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All025, scenario4VideoSegments.mentorKeys.BnScn04All026],
			isCorrect: false,
			description: 'You yell across the group room over the other Veterans present: “Stop talking about people, it\'s rude and disrespectful.”',
			feedbackHtml: 'Not the best answer! This is too strong as a preliminary intervention. While it is important to set limits and remind Veterans of their rights and responsibilities as VHA patients, it is not clinically therapeutic to yell at patients in a forceful and angry way. The ERASE model\'s first E is to Expect that mistreatment will happen and be prepared so as not to respond in anger. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All028]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario4,
			subtitle: ('Question 1'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario4VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step4b();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step4(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 0, 1, () => this.step2())
	}

	//4-b.	Time passes
	step4b() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter1Resume, () => {
			//UNCOMMENT FOR MENTOR
			updateMentorVideo(true, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All030);
			this.uiWrapper.displayIntroScreenUI({
				title: 'Information',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						After speaking with the Veterans one to one you decide to speak to all the Veterans in the dayroom.
					</p>
				</div>
				`,
				audioUrls: null,
				spaceForMentor: true,
				onStartScenarioClicked: () => {
					this.step5();
				}
			})
		});
	}

	//5.	Cinematic 2 (Video)
	step5() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter2, () => {
			this.step6();
		}, false)
	}

	//6.	Question 2
	step6(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All036);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All038, scenario4VideoSegments.mentorKeys.BnScn04All039],
			isCorrect: false,
			description: 'You state angrily: “You are not following the rules of the unit! I already told you both to stop talking about others that way!”',
			feedbackHtml: 'Not the best answer! Although you may feel angry that the Veterans are arguing with you and do not appreciate your intervention, expressing that in an angry tone is not conducive to a therapeutic environment. The ERASE model\'s first E is to Expect that mistreatment will happen and be prepared so as not to respond in anger. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All041]
		}, {
			title: 'Option 2',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All043, scenario4VideoSegments.mentorKeys.BnScn04All044],
			isCorrect: true,
			description: 'You say: “Yes, everyone is entitled to their own opinions. But gossiping and speaking negatively about other patients who are here to receive treatment is not helpful to other patients nor to yourself. I am sure you would not want other patients speaking negatively about you behind your back.”',
			feedbackHtml: 'Correct! This is using the A from the ERASE for directly addressing the unit rules to be respectful while also acknowledging that people may have differing personal opinions. The ERASE model\'s last E is to Establish a positive culture by reminding the Veterans that they have a role in creating a safe environment. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a> if clinically deemed necessary.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All046]
		}, {
			title: 'Option 3',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All048, scenario4VideoSegments.mentorKeys.BnScn04All049],
			isCorrect: true,
			description: 'You say: “Everyone is here together, everyone here has served in some capacity, and everyone is here to receive good care to address their needs. All of us should be respectful of one another even if there are differences of opinion.”',
			feedbackHtml: 'Correct! This response emphasizes that all patients are on the unit to receive treatment, people can have differing opinions and may still be respectful. The ERASE model\'s last E is to Establish a positive culture by reminding the Veterans that they have a role in creating a safe environment. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a> if clinically deemed necessary.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All052]
		}, {
			title: 'Option 4',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All054],
			isCorrect: false,
			description: 'You are shocked that they are arguing with you. You take no action and stand there, you say okay to the Veterans, and leave.',
			feedbackHtml: 'Not the best answer! Not recognizing when mistreatment occurs--the R in ERASE--by providing immediate feedback may reinforce and increase the behavior, which may negatively impact the unit milieu. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All056]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario4,
			subtitle: ('Question 2'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario4VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step6b();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step6(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 1, 2, () => this.step5())
	}

	//6-b.	Time passes
	step6b() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter2Resume, () => {
			//UNCOMMENT FOR MENTOR
			updateMentorVideo(true, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All058);
			this.uiWrapper.displayIntroScreenUI({
				title: 'Information',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
					After providing an appropriate intervention, you privately ask the two Veterans in the day room if they would join you in the unit conference room for additional discussion. As you walk into the room one of the Veterans begins to speak.
					</p>
				</div>
				`,
				audioUrls: null,
				spaceForMentor: true,
				onStartScenarioClicked: () => {
					this.step7();
				}
			})
		});
	}

	//7.	Cinematic 3 (Video)
	step7() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter3, () => {
			this.step8();
		}, false)
	}

	//8.	Question 3
	step8(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All063);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All065, scenario4VideoSegments.mentorKeys.BnScn04All066],
			isCorrect: false,
			description: 'You state: “Obviously, you are just not willing to stop talking like this. I will have to report this to the Treatment Team and discuss your inappropriate views and they might want to discuss potentially discharging you.”',
			feedbackHtml: 'Not the best answer! This is way too strong. This response shuts down the situation and also takes an authoritarian stance. Too strong of a reaction doesn\'t allow for Establishing a positive culture—the last E in ERASE model. One of the Veterans seems to be closer to being willing to resolve the situation and discuss further with you but by speaking disparagingly and threatening discharge will reinforce the negative behavior and likely escalate the situation. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All068]
		}, {
			title: 'Option 2',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All070, scenario4VideoSegments.mentorKeys.BnScn04All071],
			isCorrect: true,
			description: 'You state: “Veterans are a diverse group of people. Individuals who are transgender and gender diverse have likely had a long-standing struggle with being seen as who they are. In addition to you, everyone here has a story and lived experience that others don\'t know about. You may be able to provide support to Sally by being open and accepting of who she is without judgment. She served our country just like you did.”',
			feedbackHtml: 'Correct! Provides a teachable moment, inviting the Veterans to consider the experiences of Sally and how their gossip may contribute to making others feel bad. It also shares information that they can be supportive of Sally and invites compassion. Be aware of this behavior and if it is a pattern of behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a> if clinically deemed necessary.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All074]
		}, {
			title: 'Option 3',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All076, scenario4VideoSegments.mentorKeys.BnScn04All077],
			isCorrect: true,
			description: 'You say: “VA has a mission to serve all who serve. You asked if we could agree to disagree and I am not sure if we can.  Do we agree that all Veterans here should be respected, because I can\'t agree with disrespect. How do we ensure that all Veterans receive respect while they are here on the unit if you express your private views in front of everyone?”',
			feedbackHtml: 'Correct! This response acknowledges that the Veterans may have a difference of opinion but does not negate the need for respect. Additionally, an offer for additional education may support the needs of Sally and all the Veterans on the unit. Be aware of what these Veterans do and if it is a pattern of harassing behavior, consider the need to report this behavior to the disruptive behavior reporting system (DBRS) @ <a target="_blank" href="https://cfm.vssc.med.va.gov/dbr/main.cfm">https://cfm.vssc.med.va.gov/dbr/main.cfm</a> if clinically deemed necessary.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All079]
		}, {
			title: 'Option 4',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All081, scenario4VideoSegments.mentorKeys.BnScn04All082],
			isCorrect: false,
			description: 'You say: "You can keep talking with each other, but please talk quieter so others cannot hear you."',
			feedbackHtml: 'Not the best answer! This response reinforces the behavior, gossiping, and negative peer interactions that will impact the unit milieu. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All084]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario4,
			subtitle: ('Question 3'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario4VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step8b();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step8(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 2, 3, () => this.step7())
	}

	//8-b.	Time passes
	step8b() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter3Resume, () => {
			//UNCOMMENT FOR MENTOR
			updateMentorVideo(true, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All087);
			this.uiWrapper.displayIntroScreenUI({
				title: 'Information',
				buttonText: 'Continue',
				htmlData: `
				<div>
					<p class="black-text">
						The scene with the two Veterans and staff ends. Now it is end of their shift and employees are gathered for a shift change. Following the huddle, you overhear other staff discussing.
					</p>
				</div>
				`,
				audioUrls: null,
				spaceForMentor: true,
				onStartScenarioClicked: () => {
					this.step9();
				}
			})
		});
	}

	//9.	Cinematic 4 (Video)
	step9() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter4, () => {
			this.step10();
		}, false)
	}

	//10.	Question 4
	step10(customOptions?: GeneralQuestionUIConfigOption[]) {
		updateMentorVideo(false, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All093);
		const options = customOptions ?? [{
			title: 'Option 1',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All095, scenario4VideoSegments.mentorKeys.BnScn04All096],
			isCorrect: false,
			description: 'You state: “I kind of agree with you. I\'m uncomfortable being put in the position of sticking up for something I don\'t believe in.” ',
			feedbackHtml: 'Not the best answer! Your role and responsibility as VHA staff is to ensure that all Veterans receive inclusive and equitable care. Bystander intervention teaches that we take personal responsibility and intervene. By joining in about negative perceptions that may be based in lack of understanding, you may be inadvertently reinforcing stereotypes. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All098]
		}, {
			title: 'Option 2',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All100, scenario4VideoSegments.mentorKeys.BnScn04All101],
			isCorrect: true,
			description: 'You say: “You know, I used to not understand transgender people either. We had a presentation from the LGBTQ+ Veteran Care Coordinator a few months back and I had no idea about the challenges faced by transgender people. They also shared resources that I checked out and that was helpful too.”',
			feedbackHtml: 'Correct! Offering an alternate way of viewing the situation, what you have learned, and sharing of resources helps to strengthen the team, eliminate gossiping, and support quality Veteran care. This is an example of Establishing a positive culture--the last E in ERASE model.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All103]
		}, {
			title: 'Option 3',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All105, scenario4VideoSegments.mentorKeys.BnScn04All106],
			isCorrect: true,
			description: 'You respond with: “Hmmm. Everyone has different levels of education and understanding about what it\'s like to be transgender. As VHA staff, we need to make sure we are providing inclusive and equitable care for all the Veterans we treat on this unit. Sounds like this might be a good opportunity for our unit staff to learn more about transgender and gender diverse people. We should request a consult from our LGBTQ+ Veteran Care Coordinator who might be able to help us learn more.”',
			feedbackHtml: 'Correct! Offering an opportunity to expand knowledge and education while focusing on the need to ensure appropriate clinical care redirects the dialogue. This is an example of Establishing a positive culture--the last E in ERASE model.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All108]
		}, {
			title: 'Option 4',
			mentorVid: scenario4VideoSegments.mentorVidUrl,
			mentorOption: [scenario4VideoSegments.mentorKeys.BnScn04All110, scenario4VideoSegments.mentorKeys.BnScn04All111],
			isCorrect: false,
			description: 'You state: “I totally agree with you. I think being transgender is just something people do when they are confused.”',
			feedbackHtml: 'Not the best answer! Your role and responsibility as VHA staff is to ensure that all Veterans receive inclusive and equitable care. By joining in about negative perceptions that may be based in lack of understanding, you may be inadvertently reinforcing stereotypes. This is not a clinical response to the behavior.',
			mentorFeedback: [scenario4VideoSegments.mentorKeys.BnScn04All113]
		}]
		this.uiWrapper.displayQuestonType1UI({
			title: PageType.Scenario4,
			subtitle: ('Question 4'),
			audioUrl: null,
			options:options,
			multipleChoice: false,
			questionTitle: 'Select the response that best aligns with your action. There may be more than one appropriate response.',
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario4VideoSegments.getItemByKey('Feedback');
				this.onQuestionType1Submitted(allOptions, selectedChoices, parentQuestionConfig,
												 () => { //Next Step (if correct)
													this.step12();
												 }, (optionsToShow: GeneralQuestionUIConfigOption[]) => { //Next Step (if incorrect)
													this.step10(optionsToShow);
												 }, mentorInfo.src);
			}
		}, 3, 4, () => this.step9())
	}

	//12.	Scenario Recap
	step12() {
		this.playVideoChapter(this.partId, scenario4VideoSegments.cinematicKeys.chapter4Resume, () => {
			updateMentorVideo(false, scenario4VideoSegments.mentorVidUrl, scenario4VideoSegments.mentorKeys.BnScn04All115);
			this.setAreaForCurrentScenario(4, 5).then(() => {
				this.uiWrapper.displayIntroScreenUI({
					title: 'Scenario Completed',
					buttonText: 'Continue',
					htmlData: `
					<div>
						<p class="black-text">
							Ensuring you confront inappropriate behavior at the onset will help to reduce poor interactions amongst 
							staff and Veterans and ensure the environment is one that promotes inclusive and equitable care. When 
							inappropriate behavior is allowed to continue it can escalate and inadvertently cause additional harm to 
							the Veteran who is the recipient of the harmful comments. Avoid getting into power struggles, where you 
							are attempting to change the beliefs of another; everyone is entitled to their beliefs. Instead, we want 
							to change the behavior. Engaging in respectful discussion that maintains boundaries and the therapeutic 
							nature of the milieu is important. The goal is not to change beliefs or punish patients, it is to offer 
							education and ensure that respect is demonstrated to everyone.
						</p>
						<br />
						<p class="black-text">
							In this section you reviewed options that are consistent with the ERASE model. ERASE stands for E= Expecting 
							that negative events can occur so you can prepare for them. R=Recognize when sights, sounds, and behaviors 
							cross over. A=Addressing the situation in real time. S=Support colleagues after an incident. Finally, E=Encourage 
							a supportive and psychologically safe environment.
						</p>
					</div>
					`,
					audioUrls: null,
					onStartScenarioClicked: () => {
						this.step13();
					}
				})
			})
		}, false)
	}

	//13.	AAR
	step13() {
		Tools.getSaveData().then((savedData: CustomGameDataManager) => {
			savedData.data.scenarios[this.scenarioIndex()].isCompleted = true;
			Tools.saveGame(savedData).then(() => {
				this.uiWrapper.displayAAR(PageType.Scenario5);
			})
		})
	}
}